import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';
import authApi from "../../services/api/auth";
import {GlobalContext} from "../../context/GlobalState";
import Plaudy from 'plaudy';

const Settings = ({email}) => {
  const {logOut, userData} = useContext(GlobalContext);
  let history = useHistory();

  const handleLogout = async () => {
    try {
      await authApi.logOut();
      Plaudy.track('logout', {
        object_id: 'Settings',
        user_id: userData.id,
        email: userData.email,
      });
      logOut();
      history.push('/login');
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  const handleHome = () => {
    history.push('/home');
  }

  return (email &&
    <div className='settings-dropdown' tabIndex={0}>
      <p className='dropdown'>{email}</p>
      <div className="menu">
        <ul>
          <li onClick={handleHome}>My account</li>
          <li onClick={handleLogout}>Log out</li>
        </ul>
      </div>
    </div>
  );
};

export default Settings;
